import { createFileRoute } from "@tanstack/react-router";

import { Separator } from "@/components/ui/separator";
import { noIndexSeo } from "@/lib/seo";
import * as m from "@/paraglide/messages";

import { LinkNewIdentity } from "./-components/link-new-identity";
import { LinkedAccounts } from "./-components/linked-accounts";
import { PasswordSetup } from "./-components/password-setup";
import { ProfileForm } from "./-components/profile-form";

export const Route = createFileRoute("/(app)/settings/user")({
	component: RouteComponent,
	head: ({ match }) =>
		noIndexSeo({
			title: `${m.userSettings_title()} | StudyOS`,
			description: m.userSettings_description(),
			pathname: match.pathname,
		}),
});

function RouteComponent() {
	return (
		<div className="space-y-6">
			<div>
				<h3 className="text-lg font-medium">{m.userSettings_title()}</h3>
				<p className="text-sm text-muted-foreground">{m.userSettings_description()}</p>
			</div>
			<Separator />
			<ProfileForm />
			<LinkedAccounts />
			<LinkNewIdentity />
			<PasswordSetup />
		</div>
	);
}
